// 流程常量
// export const NODE_MIDDLE_TYPE = 1; // "中间节点"
// export const NODE_RADIO = 0; // 会签-100  其他-0
export const SKIP_TYPE = 'PASS'; // 写死 PASS往前跳 REJECT往后跳
export const START_NODE = { name: '开始', type: 0 }; // 开始节点
export const NODECODE_SEPARATOR = '::'; // nodeCode分隔符
export const MAX_MIDDLE_NODE = 10; // 最多只能有10个中间节点

// 流程节点
export const NODE = {
  START: 0, // "开始"
  APPROVE: 1, // "审核"
  COPY: 2, // "抄送"
  CONDITION: 3, // "条件"
  EXCLUSIVE_GATEWANY: 4, // "排他网关"
  END: 9, // "结束"
  // TRANSACT: 5, //"办理"
  // TRIGGER: 6, // "触发器"
} as const;

export const NODE_TYPE_PREFIX = {
  START: 'start',
  END: 'end',
  AUDIT_OR: 'auditOr',
  AUDIT_AND: 'auditAnd',
  CC: 'cc',
  CONDITION: 'condition',
} as const;

export const CODEPREFIX_TO_NODETYPE_MAP = {
  [NODE_TYPE_PREFIX.START]: NODE.START,
  [NODE_TYPE_PREFIX.END]: NODE.END,
  [NODE_TYPE_PREFIX.AUDIT_OR]: NODE.APPROVE,
  [NODE_TYPE_PREFIX.AUDIT_AND]: NODE.APPROVE,
  [NODE_TYPE_PREFIX.CC]: NODE.COPY,
  [NODE_TYPE_PREFIX.CONDITION]: NODE.EXCLUSIVE_GATEWANY,
};

export type NODE_TYPE = (typeof NODE)[keyof typeof NODE];
export type NODE_PREFIX_TYPE =
  (typeof NODE_TYPE_PREFIX)[keyof typeof NODE_TYPE_PREFIX];

// 流程执行人
export const ASSIGNEE = {
  SELF: 2, // "发起人本人"
  // SUPERIOR: 1, // "上级"
  // DEPARTMENT_LEADER: 2, // "部门负责人"
  ROLE: 4, // "角色"
  ASSIGNEE: 3, // "指定成员"
  // MULTISTEP_LEADER: 5, // "连续多级上级"
  // MULTISTEP_DEPARTMENT_LEADER: 6, // "连续多级部门负责人"
  // INITIATOR_CHOICE: 7, // "发起人自选"
} as const;

export type ASSIGNEE_TYPE = (typeof ASSIGNEE)[keyof typeof ASSIGNEE];

export const ASSIGNEE_TYPE_OPTIONS = [
  { value: ASSIGNEE.SELF, text: '发起人本人' },
  { value: ASSIGNEE.ROLE, text: '角色' },
  { value: ASSIGNEE.ASSIGNEE, text: '指定成员' },
];

export const MULTI_INSTANCE_APPROVAL_TYPE = {
  NON_MULTIPLE: 0, // "非多人审批",
  AUDIT_AND: 1, // "会签",
  AUDIT_OR: 2, // "或签"
} as const;
